module.exports = __webpack_public_path__ + "img/57.8333f331.jpg";